import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { FilterSection } from "./card/filter-section";
import { ColumnViewPanel } from "./card/column-view-panel";
import { ExportButtons } from "./card/export-buttons";
import { DataTableWrapper } from "./card/data-table-wrapper";

export const ScanTrackSummaryDataComponents = ({
  itemPerPage,
  page,
  totalCount,
  handlePageChange,
  handleItemPerPageChange,
  loading,
  filterData,
  onFilterChange,
  yearOptions,
  monthOptions,
  columnView,
  setColumnView,
  data,
  isScanTrackerLoading,
  companyOptions,
  error,
  handleExport,
  isExporting,
  branches,
  products,
  isLoadingBranches,
  isLoadingProducts,
  isLoadingFilterMode,
  branchError,
  productError,
  exportingType,
  additionalInfoFields,
  additionalInfoColumnView,
  setAdditionalInfoColumnView,
  loadingAdditionalInfoFields,
  exportLang,
  setExportLang,
  additionalInfoMeta,
}) => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h4" fontWeight="bold" mb={1}>
      Scan Track Summary
    </Typography>
    <Divider sx={{ mb: 3 }} />

    <FilterSection
      filterData={filterData}
      onFilterChange={onFilterChange}
      yearOptions={yearOptions}
      monthOptions={monthOptions}
      companyOptions={companyOptions}
      branches={branches}
      products={products}
      isLoadingBranches={isLoadingBranches}
      isLoadingProducts={isLoadingProducts}
      isLoadingFilterMode={isLoadingFilterMode}
      branchError={branchError}
      productError={productError}
    />

    {filterData.company && (
      <Box sx={{ position: "relative" }}>
        <ColumnViewPanel
          columnView={columnView}
          setColumnView={setColumnView}
          additionalInfoFields={additionalInfoFields}
          additionalInfoColumnView={additionalInfoColumnView}
          setAdditionalInfoColumnView={setAdditionalInfoColumnView}
          loadingAdditionalInfoFields={loadingAdditionalInfoFields}
        />

        <Box
          sx={{
            marginLeft: "215px",
            height: "100%",
            backgroundColor: "#fff",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
            boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.1)",
            display: "flex",
            flexDirection: "column",
            "& .MuiTableContainer-root": {
              height: "calc(100vh - 450px)",
              overflow: "auto",
              "& table": {
                width: "max-content",
                minWidth: "100%",
              },
              "&::-webkit-scrollbar": {
                width: "6px",
                height: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#cbd5e1",
                borderRadius: "3px",
              },
              "&::-webkit-scrollbar-corner": {
                backgroundColor: "transparent",
              },
            },
          }}
        >
          <ExportButtons
            handleExport={handleExport}
            isExporting={isExporting}
            exportingType={exportingType}
            data={data}
            error={error?.data}
            additionalInfoFields={additionalInfoFields}
            exportLang={exportLang}
            setExportLang={setExportLang}
          />
          <Box sx={{ overflow: "auto", flex: 1 }}>
            <DataTableWrapper
              data={data}
              isScanTrackerLoading={loading.data}
              columnView={columnView}
              itemPerPage={itemPerPage}
              page={page}
              total={totalCount}
              onPageClick={handlePageChange}
              onItemPerPageChange={handleItemPerPageChange}
              additionalInfoMeta={additionalInfoMeta}
            />
          </Box>
        </Box>
      </Box>
    )}
  </Box>
);
